import { render, staticRenderFns } from "./MyOrderConfirm.vue?vue&type=template&id=7a20b1c4&scoped=true&"
import script from "./MyOrderConfirm.vue?vue&type=script&lang=js&"
export * from "./MyOrderConfirm.vue?vue&type=script&lang=js&"
import style0 from "./MyOrderConfirm.vue?vue&type=style&index=0&id=7a20b1c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a20b1c4",
  null
  
)

export default component.exports